export const TYPICAL_CALL_DURATION_LABEL = "About 10–15 min";

export const TYPICAL_CALL_TITLE = "Typical call";
export const NO_COMMITMENT_TITLE = "No commitment yet";
export const NO_COMMITMENT_BODY = "Just to answer questions and explain next steps";
